<div class="container">
  <nav class="nav mixed-loyalty-nav my-4 d-flex flex-row justify-content-start" *autoScrollNavbar="'mixed-loyalty-nav'">
    <a
      class="nav-item nav-item-all"
      [routerLink]="['/rewards']"
      [routerLinkActive]="'active'"
      [class.active]="isActive('/rewards')"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'rewards.nav.rewards' | translate }}"
    >
      <label>{{ 'rewards.nav.rewards' | translate: { fgbdefault: 'Rewards' } }}</label>
    </a>

    <a
      class="nav-item"
      [routerLink]="['/rewards/marketplace']"
      [routerLinkActive]="'active'"
      [class.active]="isActive('/rewards/marketplace')"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'rewards.nav.rewards.marketplace' | translate: { fgbdefault: 'Move to marketplace page' } }}"
    >
      <label>{{ 'rewards.nav.rewards.marketplace' | translate }}</label>
    </a>

    <a
      class="nav-item nav-item-events"
      [routerLink]="['/rewards/events']"
      [routerLinkActive]="'active'"
      [class.active]="isActive('/rewards/events')"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'rewards.nav.rewards.events' | translate: { fgbdefault: 'Move to Events page' } }}"
    >
      <label>{{ 'rewards.nav.rewards.events' | translate }}</label>
    </a>

    <a
      class="nav-item"
      [routerLink]="['/rewards/raffles']"
      [routerLinkActive]="'active'"
      [class.active]="isActive('/rewards/raffles')"
      [routerLinkActiveOptions]="{ exact: true }"
      attr.aria-label="{{ 'rewards.nav.rewards.raffles' | translate: { fgbdefault: 'Move to Raffles page' } }}"
    >
      <label>{{ 'rewards.nav.rewards.raffles' | translate }}</label>
    </a>
  </nav>
</div>
